module.exports = __webpack_public_path__ + "media/charts/Roles&DesignBackground-7a1281bb.svg";